import Axios from 'axios';
import DataGrid, {
    Column,
    Export,
    FilterRow,
    Grouping,
    GroupPanel,
    Pager,
    Paging,
    Selection
} from 'devextreme-react/data-grid';
import RadioGroup from 'devextreme-react/radio-group';
import React, { useEffect, useRef, useState } from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { toast } from 'react-toastify';
import { Button, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { goRiceUrl } from '../../../../constant/siteConstants';
import { onExporting } from '../../../../utils/DataGridExporter';
import getConfigToken from '../../../../utils/getConfigToken';
import useFormatMessage from '../../../../utils/useFormatMessage';

export default function UpdateModal({ dataId, modalUpdate, setModalUpdate, triger, setTriger }) {
    const notifySuccess = (message) => toast.success(`${message}`);
    const notifyError = (message) => toast.error(`${message}`);
    const notify = (message) => toast.error(`${message}`);
    const [roleGroups, setRoleGroups] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [radioGroupVal, setRadioGroupVal] = useState()
    const { t } = useFormatMessage();

    useEffect(() => {
        if (dataId && UpdateModal) {
            setTimeout(() => {
                var arr = []
                dataId.roles.forEach((item) => {
                    arr.push(item.role_id)

                })
                document.getElementById("yetki-grup-adi").value = dataId.permission_group_description
                setSelectedRowKeys(arr)
            }, 300);

        }

    }, [modalUpdate, dataId])

    const pageSizes = [10, 25, 50, 100];
    let gridData = useRef()

    const roleItems = [
        // { id: 0, text: 'Full Yazma Yekisi', value: "write" },
        { id: 1, text: 'Sadece Görme Yetkisi', value: "read" },
        { id: 2, text: 'Sadece Ekleme Yetkisi', value: "add" },
        { id: 3, text: 'Sadece Güncelleme Yetkisi', value: "update" },
        { id: 4, text: 'Sadece Silme Yetkisi', value: "delete" },
        { id: 5, text: 'Sadece Excel Export Yetkisi', value: "excel" },
        { id: 6, text: 'Tüm Rolleri Kaldır', value: "" }
    ];

    async function getRoleGroups() {
        await Axios.post(`${goRiceUrl}/api/employee/getAllRolesAndRoleGroup`, {}, getConfigToken).then((resp) => {
            resp.data.forEach(obj => {

                obj.checked = false

            })
            setRoleGroups({ Datas: resp.data })
        })
            // .then(() => {
            //     setTimeout(() => {
            //         getSelectedPermissionGroupData();
            //     }, 500);
            // })
            .catch((err) => {
                console.error(err);
                notifyError("Rol Grupları yüklenirken bir servis hatası meydana geldi.");
            })
    }

    async function updatePermissionGroup() {
        const checkboxHolder = []
        var arr = Array.from(selectedRowKeys);
        arr.forEach(checks => {
            checkboxHolder.push(checks)
        })
        if (validateObject(checkboxHolder)) {
            await Axios.post(`${goRiceUrl}/api/employee/updatePermissionGroup`, {
                "permission_group_description": document.getElementById("yetki-grup-adi").value,
                "permission_group_id": dataId.permission_group_id,
                "permission_group_name": document.getElementById("yetki-grup-adi").value,
                "roles": checkboxHolder,
                "user_id": parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'))
            }, getConfigToken).then((resp) => {
                // eğer statu 200 ise 
                if (resp.status === 200) {
                    setTriger(!triger)
                    setModalUpdate(false);
                    notifySuccess("Yetki Grubu başarıyla güncellendi.");
                }
                else {
                    notifyError("Yetki Grubu güncellenirken bir hata meydana geldi.");
                }
            }).catch((err) => {
                console.error(err);
                notifyError("Yetki Grubu güncellenirken bir servis hatası meydana geldi.");
            })
        } else {
            setTimeout(() => {
                document.getElementById("saveButtonNew").disabled = false
            }, 1500)
        }
    }
    const validateObject = (checkboxHolder) => {
        var result = true
        if (document.getElementById("yetki-grup-adi").value === "") {
            result = false;
            notify("Yetki Grubu adı boş olamaz")
            return
        }
        if (checkboxHolder.length === 0) {
            result = false;
            notify("Yeki Grubu seçimi yapınız.")
            return
        }
        return result;
    }

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        if (modalUpdate === true) {
            getRoleGroups();
        }
    }, [modalUpdate])
    /* eslint-disable react-hooks/exhaustive-deps */

    function currentlySelected(selections) {
        setSelectedRowKeys(selections)
    }
    function typeOnChange(value) {
        const filterRoleGroups = []
        if (value === "read") {
            roleGroups.Datas.forEach((role) => {
                if (role.access_type === "READ")
                    filterRoleGroups.push(role.role_id)

            })

        } else if (value === "write") {

            roleGroups.Datas.forEach((role) => {
                if (role.access_type === "WRITE")
                    filterRoleGroups.push(role.role_id)

            })
        } else if (value === "add") {
            roleGroups.Datas.forEach((role) => {
                if (role.access_type === "ADD")
                    filterRoleGroups.push(role.role_id)

            })
        } else if (value === "delete") {
            roleGroups.Datas.forEach((role) => {
                if (role.access_type === "DELETE")
                    filterRoleGroups.push(role.role_id)

            })
        } else if (value === "update") {
            roleGroups.Datas.forEach((role) => {
                if (role.access_type === "UPDATE")
                    filterRoleGroups.push(role.role_id)

            })
        } else if (value === "excel") {
            roleGroups.Datas.forEach((role) => {
                if (role.access_type === "EXCEL")
                    filterRoleGroups.push(role.role_id)

            })
        }
        setSelectedRowKeys(filterRoleGroups)
        setRadioGroupVal(value)
    }


    return (
        <Modal size="lg" isOpen={modalUpdate} toggle={() => { setModalUpdate(!modalUpdate); }}>
            <ModalHeader toggle={() => { setModalUpdate(!modalUpdate); }}>
                {t("Yetki Grubu Güncelleme Formu")}
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Col lg="12">
                        <div className="dx-fieldset mb-3">
                            <Row>
                                <div xl="12" className='mb-3' style={{ width: "750px", opacity: "0.6", backgroundColor: "#1DB2F5", borderRadius: "15px", padding: "5px", marginTop: "10px" }}>
                                    <div style={{ fontSize: "18px", color: 'white', textAlign: "center", verticalAlign: "center" }}>Grup Bilgileri</div>
                                </div>
                            </Row>
                            <div className="dx-field">
                                <div className="dx-field-label" style={{ color: "black" }}>Yetki Grubu Adı</div>
                                <div className="dx-field-value">
                                    <Input id="yetki-grup-adi" />
                                </div>
                            </div>
                            <Row>

                                <Col xl="12" className='mb-4 ' style={{ width: "100px", opacity: "0.6", backgroundColor: "#1DB2F5", borderRadius: "15px", padding: "5px", marginTop: "10px" }}>

                                    <div style={{ fontSize: "18px", color: 'white', textAlign: "center", verticalAlign: "center" }}>Roller</div>

                                </Col>
                                <div className="option mb-4">
                                    <RadioGroup
                                        layout="horizontal"
                                        items={roleItems}
                                        value={radioGroupVal}
                                        valueExpr="value"
                                        displayExpr="text"
                                        itemRender={(item) => {
                                            return (
                                                <>
                                                    {t(item.text)}
                                                </>
                                            )
                                        }}
                                        onValueChanged={(e) => {
                                            typeOnChange(e.value)
                                        }}
                                    />

                                </div>
                                <DataGrid
                                    className='datagrid gridContainer-style'
                                    ref={gridData}
                                    dataSource={roleGroups.Datas !== undefined ? roleGroups.Datas : roleGroups}
                                    showBorders={true}
                                    onSelectedRowKeysChange={currentlySelected}
                                    defaultSelectedRowKeys={selectedRowKeys}
                                    selectedRowKeys={selectedRowKeys}
                                    allowColumnResizing={true}
                                    key="role_id"
                                    keyExpr="role_id"
                                    onExporting={onExporting}
                                >
                                    <Export enabled={true} />
                                    <FilterRow visible={true} />
                                    <GroupPanel visible={true} />
                                    <Grouping autoExpandAll={false} />
                                    <Selection
                                        mode="multiple"
                                        allowSelectAll={false} />
                                    {/* <Column dataField="Role_id" selectedFilterOperation={"contains"} alignment="center" /> */}
                                    <Column dataField="role_group_description" selectedFilterOperation={"contains"} caption={t("Yetki Grubu Adı")} alignment="center" groupIndex={0} />
                                    <Column dataField="role_description" selectedFilterOperation={"contains"} caption={t("Rol Adı")} alignment="center" />

                                    {/* <MasterDetail
                                        enabled={true}
                                        component={MasterDetailRolesGrid}
                                    /> */}
                                    <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                                    <Paging defaultPageSize={10} />

                                </DataGrid>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Col lg="12" className='d-flex justify-content-between align-items-center' >
                    <Button id='saveButtonNew' disabled={false} onClick={() => { updatePermissionGroup(); document.getElementById("saveButtonNew").disabled = true }} >{t("Kaydet")}</Button>
                    <Button id='cancelButtonNew' color='danger' onClick={() => { setModalUpdate(false) }} >{t("İptal")}</Button>
                </Col>
            </ModalFooter>
        </Modal>
    )
}